// Dealpagina (30-10-2026): het hotelblok (DealPartnerHotels) en de hotelregel
// onder «Kies datum en boek» (BoekKnopHotelsDatums) lezen dezelfde hotels. Eén
// gedeelde Promise per dealId, zodat de pagina precies één verzoek
// `/api/hotels/details?dealId=<id>` doet.

const cache = new Map();

/**
 * De hotels van een deal uit `/api/hotels/details` (altijd een array). Gooit
 * nooit: bij een fout of een niet-ok antwoord geeft de Promise `[]` en gaat de
 * cache-entry weg, zodat een volgende aanroep opnieuw mag vragen.
 */
export function haalDealHotels(dealId) {
  const sleutel = String(dealId);
  const bestaand = cache.get(sleutel);
  if (bestaand) return bestaand;
  const vergeet = () => {
    if (cache.get(sleutel) === belofte) cache.delete(sleutel);
    return [];
  };
  const belofte = Promise.resolve()
    .then(() => fetch(`/api/hotels/details?dealId=${dealId}`))
    .then((r) => {
      // Alleen een expliciet niet-ok antwoord telt als fout (zoals de oude
      // fetch in DealPartnerHotels, die `ok` niet las).
      if (!r || r.ok === false) return vergeet();
      return r.json().then((data) => (Array.isArray(data) ? data : []));
    })
    .catch(vergeet);
  cache.set(sleutel, belofte);
  return belofte;
}

/** Alleen voor tests: vergeet alle gedeelde verzoeken. */
export function wisDealHotelsCacheVoorTest() {
  cache.clear();
}
